module.exports = __webpack_public_path__ + "img/animals_02_H.f6c463e2.webp";